<!--能源优化投入（雷达图，柱状图）-->
<template>
  <div class="ei commonborder flex_row">
    <div id="ei_radar1" class="echarts"></div>
    <div id="ei_bar1" class="echarts"></div>
  </div>

</template>

<script>
let echarts = require('echarts/lib/echarts')
import api from '@/apis/power/power'
import { mapState } from 'vuex'
export default {
  data() {
    return {}
  },
  computed:mapState(['axisLineColor','axisLabelColor','splitLineStyle','legendTextColor']),
  methods: {
    //获取数据
    getList() {
      api.getInput({ year: '' }).then((res) => {
        if (res.code == 10000) {
          let _data = res.data
          let _year = []
          let _num = []
          for (var i in _data) {
            _year.push(_data[i].energyYear)
            _num.push(_data[i].fundInput)
          }
          this.ei_bar1(_year.reverse(), _num.reverse())
        }
      })
    },
    getListZB() {
      api.getInputZB(
        
      ).then((res) => {
        if (res.code == 10000) {
          let _data = res.data[0]
          this.ei_radar1(
            _data.fundInput,
            _data.manageInput,
            _data.equipInput,
            _data.humanInput,
            _data.artInput
          )
        }
      })
    },
    ei_radar1(a1, a2, a3, a4, a5) {
      let _arr = [a1, a2, a3, a4, a5]
      let _max = Math.max(..._arr)
      let ei_radar1 = echarts.init(document.getElementById('ei_radar1'))
      ei_radar1.setOption({
        tooltip: {
          position: [20, 20],
          textStyle: { fontSize: this.$echartsFontSize },
        },
        radar: [
          {
            indicator: [
              { name: '资金', max: _max },
              { name: '管理', max: _max },
              { name: '设备', max: _max },
              { name: '人力', max: _max },
              { name: '技术', max: _max },
            ],
            center: ['50%', '55%'], //中心点位置
            radius: '65%', //大小
            splitNumber: 5, //网线条
            shape: 'polygon', //多边形，circle圆形
            name: {
              //文字样式
              formatter: '{value}',
              fontSize: this.$echartsFontSize,
              textStyle: { color: '#ccd0f2' },
            },
            nameGap: 8,
            splitArea: {
              areaStyle: {
                color: [
                  'rgba(0, 204, 255, .6)',
                  'rgba(0, 204, 255, .5)',
                  'rgba(0, 204, 255, .4)',
                  'rgba(0, 204, 255, .3)',
                  'rgba(0, 204, 255, .2)',
                  'rgba(0, 204, 255, 0)',
                ], //大圆背景
              },
            },
            axisLine: {
              lineStyle: {
                color: 'rgba(0, 204, 255, .5)', //线条颜色
              },
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(0, 204, 255, 1)', //圆圈线条颜色
              },
            },
          },
        ],
        series: [
          {
            name: '投入值/元',
            type: 'radar',
            data: [
              {
                value: [a1, a2, a3, a4, a5],
                symbol: 'rect',
                symbolSize: 0,
                areaStyle: {
                  normal: {
                    color: 'rgba(36, 255, 177, 0.5)',
                  },
                },
                lineStyle: {
                  normal: {
                    color: '#24ffb1',
                    width: 3,
                  },
                },
              },
            ],
          },
        ],
      })
    },
    ei_bar1(a, b) {
      let ei_bar1 = echarts.init(document.getElementById('ei_bar1'))
      ei_bar1.setOption({
        color: ['#00f2fe'],

        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize }, 
          formatter:(params)=>{
            return params[0].name + '<br />'+ params[0].marker + '总投入：'+ this.$common.formatNum(params[0].value) + ' 万元';
          },
        },
        xAxis: {
          type: 'category',
          axisLabel:{color:this.axisLabelColor,fontSize:this.$echartsFontSize},
          axisLine: { lineStyle: { color:this.axisLineColor } },
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
          data: a,
        },
        yAxis: {
          name: "万元",
          type: "value",
          nameGap:this.$echartsFontSize-7,
          nameTextStyle: {   //  单位样式
            color: this.axisLabelColor,    //  字体颜色
            fontSize: this.$echartsFontSize-2, 	//  字体大小
            padding: [0,15,4,0]		//  内填充
          },
          axisLabel: { color: this.axisLabelColor, fontSize: this.$echartsFontSize },
          axisLine: { lineStyle: { color: this.axisLineColor } },
          splitLine: { lineStyle: this.splitLineStyle},
          splitNumber: 5,
        },
        grid: { left: '5%',right:'8%',top:'25%',bottom:'4%',containLabel: true},
        series: [
          {
            type: 'bar',
            barWidth:this.$echartsFontSize,
            data: b,
            label: {
              show: false,
              position: 'top',
              textStyle: { color: '#fff', fontSize: this.$echartsFontSize },
              formatter: "{c}",
            },
          },
        ],
      })
      this.$common.moveEcharts(b.length,ei_bar1)
   },
  },
  mounted() {
    this.getList()
    this.getListZB()
  },
}
</script>

<style lang="less" scoped>
.ei {
  #ei_radar1 {
    height: 100%;
    width: 40%;
  }
  #ei_bar1 {
    height: 100%;
    width: 60%;
    position: relative;
  }
  #ei_bar1::before {
    content: '历年总投入';
    position: absolute;
    top: 0.2rem;
    left: 0;
    font-size: 0.725rem;
    color: #00ccff;
  }
}
</style>